import { connect } from 'react-redux';

import CheckFriendsReferralInfo from './check-friends-referral-info.component';
import { ICheckFriendsReferralInfoDispatchProps } from './check-friends-referral-info.types';
import { gotFriendsReferralInfo, IFriendReferralsInfo } from '../friends-referral-store';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapDispatchToProps: ICheckFriendsReferralInfoDispatchProps = { gotFriendsReferralInfo };

const mapStateToProps = (state: State): IFriendReferralsInfo => ({
    isReferrer: state.friendsReferral.playerInfo?.isReferrer ?? true,
    hasEligibleOnAnyPlatform: Object.values(state.friendsReferral.platformsEligibility || {}).includes(true)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckFriendsReferralInfo);
